var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagIcon = function SvgTagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M16.124 11.43 20 7.554l-1.598-1.597c-.05.062-.111.123-.173.185a3.1 3.1 0 0 1-4.371 0 3.1 3.1 0 0 1 .185-4.544L12.446 0 8.57 3.876l1.56 1.56-.941.942-1.56-1.56L0 12.445l1.598 1.597c.05-.062.111-.123.173-.185a3.09 3.09 0 1 1 4.371 4.371c-.062.062-.123.124-.185.174L7.554 20l7.629-7.629-1.56-1.56.94-.941zm-3.69-1.82-2.056-2.056.94-.941 2.057 2.056z"
  })));
};
export default SvgTagIcon;